// extracted by mini-css-extract-plugin
export var actionButton = "_ab-1";
export var actionButtons = "_ab-2";
export var actions = "_ab-0";
export var aiUnread = "_ab-10";
export var alignCenter = "_ab-h";
export var backWrapper = "_ab-3";
export var cellContainer = "_ab-4";
export var checkboxContainer = "_ab-5";
export var contentContainer = "_ab-6";
export var contentHeader = "_ab-8";
export var conversationsTableWrapper = "_ab-s";
export var draftReplyBadgeContainer = "_ab-m";
export var dropdownItem = "_ab-b";
export var dropdownItemsContainer = "_ab-a";
export var dropdownTitle = "_ab-c";
export var errorIcon = "_ab-7";
export var filter = "_ab-d";
export var gray = "_ab-i";
export var headerActionButtons = "_ab-e";
export var headerCheckboxContainer = "_ab-f";
export var icon = "_ab-j";
export var menuContainer = "_ab-k";
export var noMoreTicketsIcon = "_ab-12";
export var noMoreTicketsSubText = "_ab-13";
export var oneLine = "_ab-l";
export var optionsButton = "_ab-n";
export var plus = "_ab-o";
export var portalButtonsWrapper = "_ab-g";
export var red = "_ab-p";
export var scrolledTop = "_ab-9";
export var search = "_ab-q";
export var selectedConversationsCount = "_ab-r";
export var spinner = "_ab-t";
export var strong = "_ab-u";
export var summaryCell = "_ab-v";
export var tableContainer = "_ab-11";
export var tagContainer = "_ab-w";
export var threeDots = "_ab-x";
export var twoLines = "_ab-y";
export var unread = "_ab-z";